@if (appBackdropService.isActive$ | async) {
  <div class="overlay blur"></div>
  <div class="overlay color"></div>
  <div class="overlay grain"></div>
  <div class="overlay grain grain2" (click)="onClick()"></div>
}
